export async function convertFileToBase64(files = []) {
  const filePromises = files.map((file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const imgDetails = {
            content: reader.result,
            name: file?.name,
            size: file?.size
          };
          resolve(imgDetails);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    }));

  const fileInfos = await Promise.all(filePromises);
  return fileInfos;
}
export const blobToFile = (blobData, fileName) => {
  if (blobData) {
    const url = window.URL.createObjectURL(
      blobData // new Blob([dataBytes])
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    link.remove();
  }
};
